export class APIOperationResult {
  public Success: boolean = false;
  public Reasons: Array<string> = new Array<string>();
  public Duplicate: boolean = false;
}
